class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    this.upsellIndex = 1; // Start at 1, main product is at 0
    this.init();
  }

  init() {
    this.buttons = this.querySelectorAll('.product-upsell__button');
    this.productForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    
    if (!this.productForm) {
      console.warn('Product form not found');
      return;
    }

    // Add click handlers to upsell buttons
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleUpsellToggle.bind(this));
    });
  }

  handleUpsellToggle(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    
    if (!variantId) return;

    if (button.classList.contains('is-selected')) {
      // Remove from selection
      button.classList.remove('is-selected');
      this.removeUpsellInput(variantId);
    } else {
      // Add to selection
      button.classList.add('is-selected');
      this.addUpsellInput(variantId);
    }
  }

  addUpsellInput(variantId) {
    // Create hidden input for this upsell
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `items[${this.upsellIndex}][id]`;
    input.value = variantId;
    input.dataset.upsellVariantId = variantId;
    input.classList.add('upsell-input');
    
    // Add quantity input
    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = `items[${this.upsellIndex}][quantity]`;
    quantityInput.value = '1';
    quantityInput.dataset.upsellVariantId = variantId;
    quantityInput.classList.add('upsell-input');
    
    this.productForm.appendChild(input);
    this.productForm.appendChild(quantityInput);
    
    this.upsellIndex++;
  }

  removeUpsellInput(variantId) {
    // Remove all inputs for this variant
    const inputs = this.productForm.querySelectorAll(`input.upsell-input[data-upsell-variant-id="${variantId}"]`);
    inputs.forEach(input => input.remove());
    
    // Reindex remaining upsell inputs
    this.reindexUpsellInputs();
  }

  reindexUpsellInputs() {
    const upsellInputs = this.productForm.querySelectorAll('input.upsell-input');
    let currentIndex = 1;
    
    // Group inputs by variant ID
    const variantGroups = {};
    upsellInputs.forEach(input => {
      const variantId = input.dataset.upsellVariantId;
      if (!variantGroups[variantId]) {
        variantGroups[variantId] = [];
      }
      variantGroups[variantId].push(input);
    });
    
    // Reindex each group
    Object.values(variantGroups).forEach(group => {
      group.forEach(input => {
        if (input.name.includes('[id]')) {
          input.name = `items[${currentIndex}][id]`;
        } else if (input.name.includes('[quantity]')) {
          input.name = `items[${currentIndex}][quantity]`;
        }
      });
      currentIndex++;
    });
    
    this.upsellIndex = currentIndex;
  }
}

customElements.define('product-upsell', ProductUpsell);
